import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { getMorbidityRate, getPopulationRate } from '../../reducer/morbidityRateSlice';
import { getCompareValue } from '../../reducer/patientCompareSlice';
import { getPatient } from '../../reducer/patientSlice';
import { useSelector } from 'react-redux';
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, useGridApiRef } from '@mui/x-data-grid-pro';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { Button, Typography } from '@mui/material';
import { getCluster } from '../../reducer/clusterSlice';
import dayjs from 'dayjs';
import { getSpotmap } from '../../reducer/spotmapSlice';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import dotenv from 'react-dotenv';
import { getD506UpdateTime } from '../../reducer/updateTimeSlice';
import { ExportMenu } from "./ExcelExport/ExportMenu";
// function CustomToolbar() {
//     return (
//         <GridToolbarContainer >
//             <Button>Auto Size</Button>
//             <GridToolbarColumnsButton />
//             <GridToolbarFilterButton />
//             <GridToolbarDensitySelector />
//             <GridToolbarExport />
//         </GridToolbarContainer>
//     );
// }

function Table() {
    const morbidityValue = useSelector(getMorbidityRate);
    const compareValue = useSelector(getCompareValue);
    const areaLevel = useSelector(getAreaLevel);
    const areaSelected = useSelector(getAreaSelected);
    const population = useSelector(getPopulationRate);
    const patientValue = useSelector(getPatient);
    const clusterValue = useSelector(getCluster);
    const spotmapValue = useSelector(getSpotmap);
    const d506UpdateTime = useSelector(getD506UpdateTime);
    const [dataTable, setDataTable] = useState([]);
    const [dataTableShow, setDataTableShow] = useState([]);
    const [columns, setColumns] = useState([]);
    const [pinColumns, setPinColumns] = useState([]);
    const refTable = useGridApiRef();
    const autoSizeOptions = {
        // columns: ['value', 'result'],
        includeOutliers: true,
        includeHeaders: true,
        expand: true
    }
    // const [loading, setLoading] = useState(true);

    const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
        // borderStyle: 'solid',
        border: 0,
        // border: '1 solid #000000',
        color:
            theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
        WebkitFontSmoothing: 'auto',
        letterSpacing: 'normal',
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
        },
        '& .MuiDataGrid-iconSeparator': {
            // display: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
            borderTop: `1px solid ${theme.palette.mode === 'light' ? 'rgba(224, 224, 224, 1)' : '#303030'}`
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
            borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
        },
        '& .MuiDataGrid-cell': {
            color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
        },
        '& .MuiPaginationItem-root': {
            borderRadius: 0,
        },
        // ...customCheckbox(theme),
    }));

    const CustomToolbar = () => {
        // console.log(d506UpdateTime)
        return (
            <GridToolbarContainer sx={{
                // bgcolor: 'red'
            }}>
                <Button
                    // variant="outlined"
                    onClick={() => {
                        // console.log(refTable.current);
                        refTable.current.autosizeColumns(autoSizeOptions);
                        // refTable.current.auto
                    }}
                >Auto Size</Button>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                {/* <GridToolbarExport /> */}
                <ExportMenu options={{ fileName: "export" }} />
                <div style={{
                    // backgroundColor: 'blue',
                    flex: 1,
                    display: 'flex',
                    // height: '100%',
                    alignItems: 'center',
                    justifyContent: 'end'
                }}>
                    <Typography
                        sx={{
                            paddingRight: '5px',
                            color: "#1976d2",
                            fontSize: '14px',
                            textAlign: 'right'
                        }}
                        className='font-primary'
                    >
                        อัพเดทข้อมูลวันที่ {dayjs(d506UpdateTime).format("DD MMMM BBBB")}
                    </Typography>
                </div>
            </GridToolbarContainer>
        );
    }

    useEffect(() => {
        const hasMorbidity = Object.keys(morbidityValue).length !== 0;
        const hasCompare = Object.keys(compareValue).length !== 0;
        const hasPatient = Object.keys(patientValue).length !== 0;
        const hasCluster = Object.keys(clusterValue).length !== 0;
        const hasSpotMap = Object.keys(spotmapValue).length !== 0;
        let tmpColumn = [];
        if (areaLevel === "province") {
            setPinColumns(['province_name']);
            tmpColumn.push({ field: 'province_name', headerName: 'จังหวัด', width: 160 });
        } else if (areaLevel === 'amphur') {
            setPinColumns(['province_name', 'amphur_name']);
            tmpColumn.push({ field: 'province_name', headerName: 'จังหวัด', width: 160 });
            tmpColumn.push({ field: 'amphur_name', headerName: 'อำเภอ', width: 160 });
        } else {
            setPinColumns(['province_name', 'amphur_name', 'tambon_name']);
            tmpColumn.push({ field: 'province_name', headerName: 'จังหวัด', width: 160 });
            tmpColumn.push({ field: 'amphur_name', headerName: 'อำเภอ', width: 160 });
            tmpColumn.push({ field: 'tambon_name', headerName: 'ตำบล', width: 160 });
        }

        if (hasMorbidity) {
            tmpColumn.push({ field: 'patient', headerName: 'จำนวนผู้ป่วย', type: 'number', width: 130 });
            tmpColumn.push({ field: 'population', headerName: 'จำนวนประชากร', type: 'number', width: 130 });
            tmpColumn.push({ field: 'value', headerName: `อัตราป่วยต่อประชากร ${population.toLocaleString()} คน`, type: 'number' });
        } else if (hasCompare) {
            tmpColumn.push({ field: 'patient', headerName: 'จำนวนผู้ป่วย', type: 'number', width: 130 });
            tmpColumn.push({ field: 'median', headerName: 'มัธยฐาน 5 ปี', type: 'number', width: 130 });
            tmpColumn.push({ field: 'result', headerName: 'ความเสี่ยง', width: 130 });
        }

        if (hasPatient) {
            if (tmpColumn.findIndex(({ field }) => field === "patient") === -1) {
                tmpColumn.push({ field: 'patient', headerName: 'จำนวนผู้ป่วย', type: 'number', width: 130 });
            }
        }

        if (hasCluster) {
            if (tmpColumn.findIndex(({ field }) => field === "amphur_name") === -1) {
                tmpColumn.push({ field: 'amphur_name', headerName: 'อำเภอ', width: 160 });
                tmpColumn.push({ field: 'tambon_name', headerName: 'ตำบล', width: 160 });
            } else if (tmpColumn.findIndex(({ field }) => field === "tambon_name") === -1) {
                tmpColumn.push({ field: 'tambon_name', headerName: 'ตำบล', width: 160 });
            }
            tmpColumn.push({
                field: 'treated_date_start',
                headerName: 'วันเริ่มกลุ่ม',
                valueGetter: ({ value }) => value && dayjs(value).toDate(),
                valueFormatter: (params) => {
                    if (params.value === undefined) {
                        return '-';
                    }
                    return `${dayjs(params.value).format('DD MMMM BBBB')}`;
                },
                type: 'date',
                width: 160
            });
            tmpColumn.push({
                field: 'treated_date_end',
                headerName: 'วันสิ้นสุดกลุ่ม',
                valueGetter: ({ value }) => value && dayjs(value).toDate(),
                valueFormatter: (params) => {
                    if (params.value === undefined) {
                        return '-';
                    }
                    return `${dayjs(params.value).format('DD MMMM BBBB')}`;
                },
                type: 'date',
                width: 160
            });
            tmpColumn.push({ field: 'npatients', headerName: 'จำนวนผู้ป่วยในกลุ่ม', type: 'number', width: 160 });
            tmpColumn.push({ field: 'cluster_length_day', headerName: 'ระยะเวลา', type: 'number', width: 160 });
            tmpColumn.push({ field: 'cluster_length', headerName: 'รุ่นการระบาด', type: 'number', width: 160 });
        }

        if (hasSpotMap) {
            if (tmpColumn.findIndex(({ field }) => field === "amphur_name") === -1) {
                tmpColumn.push({ field: 'amphur_name', headerName: 'อำเภอ', width: 160 });
                tmpColumn.push({ field: 'tambon_name', headerName: 'ตำบล', width: 160 });
            } else if (tmpColumn.findIndex(({ field }) => field === "tambon_name") === -1) {
                tmpColumn.push({ field: 'tambon_name', headerName: 'ตำบล', width: 160 });
            }
            tmpColumn.push({ field: 'gender', headerName: 'เพศ', width: 160 });
            tmpColumn.push({ field: 'age', headerName: 'อายุ', type: 'number', width: 160 });
            tmpColumn.push({
                field: 'treated_date',
                headerName: 'วันที่เริ่มรักษา',
                valueGetter: ({ value }) => value && dayjs(value).toDate(),
                valueFormatter: (params) => {
                    if (params.value === undefined) {
                        return '-';
                    }
                    return `${dayjs(params.value).format('DD MMMM BBBB')}`;
                },
                type: 'date',
                width: 160
            });
            tmpColumn.push({
                field: 'onset_date',
                headerName: 'วันที่ป่วย',
                valueGetter: ({ value }) => value && dayjs(value).toDate(),
                valueFormatter: (params) => {
                    if (params.value === undefined) {
                        return '-';
                    }
                    return `${dayjs(params.value).format('DD MMMM BBBB')}`;
                },
                type: 'date',
                width: 160
            });
        }

        setColumns(tmpColumn)

        let tmpNewData = [];

        if (hasMorbidity || hasCompare) {
            if (hasMorbidity) {
                tmpNewData = [...Object.values(morbidityValue)];
            } else {
                tmpNewData = [...Object.values(compareValue)];
            }
        } else if (hasPatient) {
            tmpNewData = [...Object.values(patientValue)];
        }

        if (hasCluster && hasSpotMap) {
            let newDataMap = {};
            let spotmapValueKey = Object.keys(spotmapValue);
            for (let index = 0; index < spotmapValueKey.length; index++) {
                const areaCode = spotmapValueKey[index];
                const spotmapList = spotmapValue[areaCode];
                const clusterList = clusterValue[areaCode];
                for (let index = 0; index < spotmapList.length; index++) {
                    const spotmapData = spotmapList[index];
                    let newData = {
                        ...spotmapData,
                    }
                    if (clusterList === undefined) {
                        newData["cluster_length_day"] = "-";
                    } else {
                        const clusterFindData = clusterList.find((clusterData) => {
                            return clusterData.tambon_code === spotmapData.tambon_code;
                        })
                        if (clusterFindData === undefined) {
                            newData["cluster_length_day"] = "-";
                        } else {
                            newData = {
                                ...spotmapData,
                                ...clusterFindData
                            }
                        }
                    }

                    if (index === 0) {
                        newDataMap[areaCode] = [newData];
                    } else {
                        newDataMap[areaCode].push(newData);
                    }
                }
            }

            if (tmpNewData.length === 0) {
                const clusters = Object.values(newDataMap);
                for (let index = 0; index < clusters.length; index++) {
                    const element = clusters[index];
                    for (let index = 0; index < element.length; index++) {
                        const clusterData = element[index];
                        tmpNewData.push(clusterData);
                    }
                }
            } else {
                let newTmpData = [];
                for (let index = 0; index < tmpNewData.length; index++) {
                    const element = tmpNewData[index];
                    const clusters = newDataMap[element.code];
                    if (clusters !== undefined) {
                        for (let index = 0; index < clusters.length; index++) {
                            const clusterData = clusters[index];
                            let data = {
                                ...element,
                                ...clusterData
                            }
                            newTmpData.push(data);
                        }
                    } else {
                        let data = {
                            ...element
                        }
                        const dataKey = Object.keys(element);
                        if (dataKey.indexOf("amphur_code") === -1) {
                            data["amphur_name"] = "-";
                            data["tambon_name"] = "-";
                        } else if (dataKey.indexOf("tambon_name") === -1) {
                            data["tambon_name"] = "-";
                        }
                        data["cluster_length_day"] = "-";
                        data["age"] = "-";
                        data["gender"] = "-";
                        newTmpData.push(data);
                    }
                }
                tmpNewData = [...newTmpData];
            }
        } else {
            if (hasCluster) {
                if (tmpNewData.length === 0) {
                    const clusters = Object.values(clusterValue);
                    for (let index = 0; index < clusters.length; index++) {
                        const element = clusters[index];
                        for (let index = 0; index < element.length; index++) {
                            const clusterData = element[index];
                            tmpNewData.push(clusterData);
                        }
                    }
                } else {
                    let newTmpData = [];
                    for (let index = 0; index < tmpNewData.length; index++) {
                        const element = tmpNewData[index];
                        const clusters = clusterValue[element.code];
                        // console.log(element.code);
                        // console.log(clusters);
                        if (clusters !== undefined) {
                            for (let index = 0; index < clusters.length; index++) {
                                const clusterData = clusters[index];
                                let data = {
                                    ...element,
                                    ...clusterData
                                }
                                newTmpData.push(data);
                            }
                        } else {
                            let data = {
                                ...element
                            }
                            const dataKey = Object.keys(element);
                            if (dataKey.indexOf("amphur_code") === -1) {
                                data["amphur_name"] = "-";
                                data["tambon_name"] = "-";
                            } else if (dataKey.indexOf("tambon_name") === -1) {
                                data["tambon_name"] = "-";
                            }
                            data["cluster_length_day"] = "-";
                            newTmpData.push(data);
                        }
                    }
                    tmpNewData = [...newTmpData];
                }
            }
            if (hasSpotMap) {
                if (tmpNewData.length === 0) {
                    const spotmaps = Object.values(spotmapValue);
                    for (let index = 0; index < spotmaps.length; index++) {
                        const element = spotmaps[index];
                        for (let index = 0; index < element.length; index++) {
                            const spotmapData = element[index];
                            tmpNewData.push(spotmapData);
                        }
                    }
                } else {
                    let newTmpData = [];
                    for (let index = 0; index < tmpNewData.length; index++) {
                        const element = tmpNewData[index];
                        const spotmaps = spotmapValue[element.code];
                        if (spotmaps !== undefined) {
                            for (let index = 0; index < spotmaps.length; index++) {
                                const spotmapData = spotmaps[index];
                                let data = {
                                    ...element,
                                    ...spotmapData
                                }
                                newTmpData.push(data);
                            }
                        } else {
                            let data = {
                                ...element
                            }
                            const dataKey = Object.keys(element);
                            if (dataKey.indexOf("amphur_code") === -1) {
                                data["amphur_name"] = "-";
                                data["tambon_name"] = "-";
                            } else if (dataKey.indexOf("tambon_name") === -1) {
                                data["tambon_name"] = "-";
                            }
                            data["age"] = "-";
                            data["gender"] = "-";
                            newTmpData.push(data);
                        }
                    }
                    tmpNewData = [...newTmpData];
                }
            }
        }

        setDataTable(tmpNewData);
        // setLoading(true);
    }, [morbidityValue, compareValue, patientValue, clusterValue, spotmapValue])

    useEffect(() => {
        const filterData = async () => {
            if (areaSelected.level === 1) {
                setDataTableShow([...dataTable]);
            } else {
                let tmpData = [];
                let provinceList = [];
                // console.log(areaSelected);
                if (areaSelected.level === 2) {
                    const response = await fetch(`${dotenv.MASTER_API_URL}/area/province?dpc_code=${areaSelected.value}`);
                    provinceList = await response.json();
                }
                for (let index = 0; index < dataTable.length; index++) {
                    const element = dataTable[index];
                    if (areaSelected.level === 2) {
                        let searchIndex = provinceList.findIndex(({ prov_code }) => prov_code === element.province_code);
                        if (searchIndex !== -1) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 3) {
                        if (element.province_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 4) {
                        if (element.amphur_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    } else if (areaSelected.level === 5) {
                        if (element.tambon_code === areaSelected.value) {
                            tmpData.push(element);
                        }
                    }
                }
                setDataTableShow(tmpData);
            }
        }
        if (dataTable.length !== 0) {
            filterData();
        }
    }, [dataTable, areaSelected])

    const getRowId = (row) => {
        if (row.patient_id) {
            return row.patient_id;
        } else if (row.tambon_code) {
            return row.tambon_code;
        } else if (row.amphur_code) {
            return row.amphur_code;
        } else if (row.province_code) {
            return row.province_code;
        }
        // return row.code;
    }

    return (
        <div style={{
            marginTop: 10,
            height: 'calc(100% - 10px)',
            // backgroundColor: 'red'
        }}>
            <StyledDataGrid
                apiRef={refTable}
                hideFooter
                rows={dataTableShow}
                columns={columns}
                initialState={{ pinnedColumns: { left: pinColumns } }}
                getRowId={getRowId}
                slots={{
                    toolbar: CustomToolbar
                }}
                autosizeOnMount
                autosizeOptions={autoSizeOptions}
            />

            {/* <DataGridPro
                hideFooter
                rows={dataTable}
                columns={columns}
                initialState={{ pinnedColumns: { left: pinColumns } }}
                getRowId={getRowId}
                // autoHeight
                slots={{
                    toolbar: GridToolbar
                }}
                autosizeOptions={{
                    // columns: ['value', 'result'],
                    includeOutliers: true,
                    includeHeaders: true,
                    expand: true
                }}
            /> */}
        </div>
    )
}

export default Table
